import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { MoverStock, Producto } from '../models/producto';
import { DataCombo } from '../models/combo';

@Injectable({
  providedIn: 'root'
})

export class ProductoService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + 'producto/';
  }

  getProductosByBaseProductoId(id: number): Observable<Producto[]> {
    let urlcom = this.url + id + '/tiendas';
    return this.http.get<Producto[]>(urlcom);
  }

  getById(id: number): Observable<Producto> {
    let urlcom = this.url + id;
    return this.http.get<Producto>(urlcom);
  }

  update(id: number, data: Producto): Observable<Producto> {
    let urlcom = this.url + id;
    return this.http.put<Producto>(urlcom, data);
  }

  updateProductos(data: Array<Producto>): Observable<Array<Producto>> {
    return this.http.put<Array<Producto>>(this.url, data);
  }

  save(data: Producto): Observable<Producto> {
    let urlcom = this.url + "register/";
    return this.http.post<Producto>(urlcom, data);
  }

  moverStock(data: MoverStock): Observable<Array<Producto>> {
    let urlcom = this.url + "moverStock/";
    return this.http.post<Array<Producto>>(urlcom, data);
  }

  delete(id: number): Observable<any> {
    let urlcom = this.url + id;
    return this.http.delete(urlcom);
  }

  activate(id: number): Observable<any> {
    let urlcom = this.url + "activate/" + id;
    return this.http.put(urlcom, null);
  }

  getProductosCombo(tiendaId: number): Observable<DataCombo[]> {
    let urlcom = this.url + "combo/" + tiendaId;
    return this.http.get<DataCombo[]>(urlcom);
  }

}
